import { Component, HostListener, isDevMode, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActiveRentalService, BookingService, NavigationService } from 'app-components';
import { ApiService, AuthService, LocalStorage, RentalInfo, SettingsService, T4Environment, UIService } from 't4core';
import { trigger, transition, state, style, animate } from '@angular/animations';
import { LayoutService } from 'app-components';
import { fader } from './route-animations';
import { MatDialog } from '@angular/material/dialog';
import { AppIntegrationService, AppSettingsService } from 't4-app-integration';
import { TranslationService } from 't4core';
import { Router } from '@angular/router';
import { InsightsService } from 't4core';

@Component({
    selector: 'app-root[osk-root]',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent {
  title = "app";
  public menuToggle = false;
  public menuComponentToggle = false;
  public firstClick = true;
  public isShowMenu: boolean = true; 
  public pageHeight: number;
  public viewHeight: number;
  public hideBackButton: boolean = false;
  public load: string = "loaded";
  public showCancelLoad: boolean = false;
  public openDialogCounter: number = 0;
  public isApp: boolean;
  public isStarting: boolean = true;


  private height: number = 0;

  public showTestMessage: boolean = true;
  public showChatInvite: boolean = false;

  public userClosedChatInfo: boolean = false;
  constructor(
  
    public t: Title,
    private navigation: NavigationService,
    public appSettings: AppSettingsService,
    public UI: UIService,
    public dialog: MatDialog,
    public layout: LayoutService,
    public appSvc: AppIntegrationService,
    private bookingSvc: BookingService,
    private settings: SettingsService, 
    private auth: AuthService,
    private renderer: Renderer2,
    private appIntegration: AppIntegrationService,
    private translate: TranslationService, private api: ApiService, private router: Router, private rentalService: ActiveRentalService, private insights: InsightsService)
  {
    this.auth.clearTokens(new Date(2025, 4, 24, 10,0,0));
    this.appIntegration.nfcDetected.subscribe(x => {

      var parts = x.split('://');
      var app = parts[0];
      var regno = "";
      var action = "";

      if (parts.length > 1) {
        parts = parts[1].split('#');
        regno = parts[0];
        action = parts.length > 1 ? parts[1] : '';
      }

      if (this.appSettings.userId) {
        if (action == "Pickup") this.rentalService.pickupByNfc(regno);
        if (action == "Return") this.rentalService.returnByNfc(regno);
      }
    });

    this.appSettings.getClientVersion(true).then(x => {
      setInterval(() => appSettings.getClientVersion().then(x => {
        if (!x[1]) navigation.reload();
      }), 1800000);
    });
    
    this.isShowMenu = appSettings.appType === 'app';
    this.isApp = this.appSettings.appType === 'app';
  }

  public async ngOnInit() {
    this.showChatInvite = true;
    this.isShowMenu = this.appSettings.appType === 'app';
    this.isApp = this.appSettings.appType === 'app';

    this.pageHeight = window.screen.height;
    this.viewHeight = window.innerHeight;

    this.isStarting = false; 
    if (!this.isApp) { 
      this.appSettings.setUser(null);
    }

    this.setupHeightMessage();

   this.userClosedChatInfo = localStorage.getItem('chatInfoClosed') ? true : false;

    this.insights.trackTrace("Web app loading complete");
    this.appSvc.notifyLoadingComplete();
    await this.appSvc.setUserInfo();
  }

  public back() { 
    if (this.hideBackButton) return;

    this.hideBackButton = true;
    this.navigation.back();

    setTimeout(() => {
      this.hideBackButton = false;
    },
      500);
  }

  public showMenu() {
    this.appSvc.requestDeviceState();
    this.menuComponentToggle = !this.menuComponentToggle;

    if (!this.menuToggle || this.firstClick) {
      this.menuToggle = !this.menuToggle;
      this.firstClick = false;
    }

    else {
      setTimeout(() => {
        this.menuToggle = !this.menuToggle;
      },
        100);

    }
  }

  public displayCancelLoad() {
    this.showCancelLoad = true;
  }

  public cancelLoad() {
    this.showCancelLoad = false;
  }

  prepareRoute(outlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }

  private setupHeightMessage() {
    // Monitor height of view-actions
    setInterval(() => {
      const elemActions = document.querySelector('.view-actions');

      if (elemActions) {
        this.layout.actionAreaHeight = elemActions.clientHeight;
      } else {
        this.layout.actionAreaHeight = 0;
      }

    }, 2000);

    if (this.isApp) return;

    // Report height to iframe parent
    const message = () => {
      let headerHeight = 0;
      let contentHeight = 500;
      let footerHeight = 0;

      // Get content element (If not fullscreen, then we keen original size)
      let contentView = document.querySelector('.view-content:not(.fullscreen)');
      if (contentView !== null) {
        contentHeight = contentView.clientHeight;
      }

      // If content hasnt changed height, dont resize frame.
      if (contentHeight === this.height) return;

      // Find header and get the height (Unless overlay, then its height is already included in content)
      let headAction = document.querySelector('.view-title:not(.overlay)');
      if (headAction !== null) {
        headerHeight = headAction.clientHeight;
      }


     // Find vie-actions and get its height
      let contentAction = document.querySelector('.view-actions');
      if (contentAction !== null) {
          footerHeight = contentAction.clientHeight;
      }

      // Save height and notify frame parent
      this.height = contentHeight;
      parent.postMessage(headerHeight + contentHeight + footerHeight, '*');
    };
    setInterval(message, 100);
  }

  public hideTestMessage() {
    this.showTestMessage = false;
    setTimeout(() => this.showTestMessage = true, 5000);
  }

  async navigate(target: string) {
    const config = this.navigation.activeStep?.ConfirmOnLeave;

    if (config) {
      const confirmed = await this.UI.confirm(
       config.TitleKey,
       config.TitleText,
       config.ContentKey,
       config.ContentText
      );

      if (!confirmed) {
        return;
      }
    }
    this.navigation.navigateToView(target);
  }
  public openChatFromInvite() {
    this.dismissChatInvite();
  }

  public dismissChatInvite() {
    localStorage.setItem('chatInfoClosed', 'true');
    this.showChatInvite = false;
  }
  
}
